//⚠️IMPACT attention changer dans le fichier prisma l'enum ProfessionalOrigin (mêmes valeurs, même ordre)
import { validateEnumTranslations } from '../../safety_checks';

/**
 * Origine d'une entreprise (`professional.origin`).
 * - `SIGNUP` : créée par l'inscription (essai gratuit, conversion d'acquisition).
 * - `ADDITIONAL_COMPANY` : créée par un propriétaire depuis son compte existant — payante
 *   d'emblée, sans essai, hors statistiques d'essai et d'acquisition.
 */
export enum ProfessionalOrigin {
  SIGNUP = 'SIGNUP',
  ADDITIONAL_COMPANY = 'ADDITIONAL_COMPANY',
}

export const TRANSLATE_KEY_PROFESSIONAL_ORIGIN = 'PROFESSIONAL_ORIGIN_';

/** Libellés du badge d'origine de la liste admin des pros. */
export const ProfessionalOriginTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PROFESSIONAL_ORIGIN}${ProfessionalOrigin.SIGNUP}`]: 'Inscription',
    [`${TRANSLATE_KEY_PROFESSIONAL_ORIGIN}${ProfessionalOrigin.ADDITIONAL_COMPANY}`]: 'Entreprise supplémentaire',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(ProfessionalOrigin, ProfessionalOriginTranslation, TRANSLATE_KEY_PROFESSIONAL_ORIGIN, true);
